import React, {Component} from 'react';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import {SEARCH_URL, REPLY_URL} from './utils/appConfig';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import Input from './containers/Input';
import Table from './containers/Table';
import {theme} from './assets/theme'
import './App.css';
import service from './assets/images/service.png';
import Enumerable from 'linq';

const keywords = [];

const styles = {
    content: {
        width: '90vw',
        margin: 'auto',
        marginTop: 50
    },
    img:{
        width: '100%'
    }
};

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keyword: "",
            keywords: localStorage.getItem("keywords") ? JSON.parse(localStorage.getItem("keywords")) : keywords,
            head: [
                {name: 'SENTIMENT', width: '5%'},
                {name: 'RESOURCES', width: '75%'},
                {name: 'STATUS', width: '20%'}
            ],
            negative: [],
            positive: [],
            finish: [],
            tweet_limit: 5
        };
    }

    componentWillUnmount() {
        localStorage.setItem('keywords', JSON.stringify(this.state.keywords));
    }

    /*
     *  comment 関連
     * */
    comment = (name, id, comment) => this.setState({[name]: [...this.state[name].map(elem => elem.id === id ? {...elem, comment} : elem)]})

    reply = (name, id, user_id, reply_text) => {
        const options = {
            method: 'post',
            body: JSON.stringify({id, user_id, reply_text})
        };

        /*axios({
            method:'get',
                url:'http://bit.ly/2mTM3nY',
                responseType:'stream'
        }) .then(res => res.json())
            .then(res => {
                console.info(res);
                this.setState({[name]: [...this.state[name].map(elem => elem.id === id ? {...elem, replied: true} : elem)]})
            })
            .catch(err => alert(err))*/

        fetch(REPLY_URL, options)
            .then(res => res.json())
            .then(res => {
                console.info(res);
                this.setState({[name]: [...this.state[name].map(elem => elem.id === id ? {...elem, replied: true} : elem)]})
            })
            .catch(err => alert(err))
    };

    /*
    *  keyword 関連
    * */
    changeKeyWord = (keyword) => this.setState({keyword});

    setKeyWord = (keyword) => {
        localStorage.setItem('keywords', JSON.stringify([...this.state.keywords, {name: keyword, selected: false}]));
        this.setState({keywords: [...this.state.keywords, {name: keyword, selected: false}]})
    };

    removeKeyWord = (keyword) => {
        let newKeywords = this.state.keywords.filter(elem => elem.name !== keyword);
        localStorage.setItem('keywords', JSON.stringify([...newKeywords]));
        this.setState({keywords: [...newKeywords]})
    };

    selectKeyWord = (keyword) => {
        let newKeywords = this.state.keywords.map(elem => elem.name === keyword ? {
            ...elem,
            selected: !elem.selected
        } : elem);
        this.setState({keywords: [...newKeywords]})
    };

    search = () => {
        const options = {
            method: 'post',
            // body: JSON.stringify({search_text: this.state.keywords.filter(elem => elem.selected).map(elem => elem.name).concat(this.state.keyword.split(" "))})
            body: JSON.stringify({search_text: this.state.keyword, tweet_limit: this.state.tweet_limit})
        };

        fetch(SEARCH_URL, options)
            .then(res => res.json())
            .then(res => {
                console.info(res)
                this.setState({
                    negative: res.filter(elem => !elem.reply_text && elem.negative > 0).map(elem => ({...elem, comment: 'Please allow me to apologize for the inconvenience. As you know, we don’t usually have problems like this, so I hope you can excuse us this time. I’m going to send out the correct copy paper and binders with a revised invoice that reflects the items we’ve discussed.'})),
                    positive: res.filter(elem => !elem.reply_text && elem.positive > 0).map(elem => ({...elem, comment: 'Thank you for your words. We are very happy to hear that. Hope, you will have enjoy it!'})),
                    finish: res.filter(elem => elem.reply_text),
                })
            }).catch(err => console.log(err))

        // setTimeout(()=>this.search(), 1000)
    };

    render() {

        const {classes} = this.props;
        const {
            keyword,
            head,
            negative,
            finish,
            positive,
            keywords
        } = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                <Header/>
                <div className={classes.content}>
                    <img className={classes.img} src={service} alt="service"/>
                    <Input keyword={keyword} keywords={keywords} setKeyWord={this.setKeyWord}
                           removeKeyWord={this.removeKeyWord} selectKeyWord={this.selectKeyWord}
                           changeKeyWord={this.changeKeyWord} search={this.search}/>
                    <Table head={head} negative={negative} positive={positive} finish={finish} reply={this.reply}
                           comment={this.comment}/>
                </div>
                <Footer/>
            </MuiThemeProvider>
        );
    }
}

export default withRouter(withStyles(styles)(App));
